// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"ZX-z","sponsoredTooltipWrapper":"_X-z","sponsoredTooltip":"aY-z","newCard":"bY-z"};